import find from 'lodash/find';
import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';
import every from 'lodash/every';
import extend from 'lodash/extend';
import reduce from 'lodash/reduce';
import mapValues from 'lodash/mapValues';
import { getValueByNs } from '@Hooks/LibraryInitialization/MoreUnderscore';

import { SELECT_WRAP_SYMBOL, BLACKLIST_CONCEPT_TAGS } from './QuickSearchAutosuggestConstants';

export function generateSelectedKey(selected, metadata) {
  const { start } = metadata;
  return `${start}`;
}

export function generateSelectedTitle(selected) {
  return getValueByNs(selected, 'title');
}

export function generateSelectedTypeahead(selected, metadata) {
  const Typeahead = getValueByNs(selected, 'Typeahead');
  const { start, end } = metadata;

  return { ...Typeahead, Start: start, End: end };
}

export function generateSelectedAnalytics(selected, metadata) {
  const { title, category } = selected;
  const { index, query, totalMatches, hasExactMatch } = metadata;

  return {
    suggestedClickPosition: index + 1,
    suggestedLetterCount: query.length,
    suggestedResultCount: totalMatches,
    typedTerm: query,
    selectedTerm: title,
    autoSuggestCategory: category,
    _typedTermListed: hasExactMatch,
  };
}

// Immutable Map
export function filterSelectedMapStillInUse(selectedMap, inputValue) {
  return selectedMap.filter((selected) => {
    const Start = selected.getIn(['Typeahead', 'Start']);
    const End = selected.getIn(['Typeahead', 'End']);
    const Label = selected.getIn(['Typeahead', 'Label']);
    const isBlacklistedConcept =
      selected.getIn(['Typeahead', 'Category']) === 'CONCEPT' &&
      !!find(BLACKLIST_CONCEPT_TAGS, (blacklisted) => blacklisted.toLowerCase() === selected.get('title'));

    return (
      !isBlacklistedConcept &&
      inputValue.substring(Start - SELECT_WRAP_SYMBOL.length, End + SELECT_WRAP_SYMBOL.length) ===
        `${SELECT_WRAP_SYMBOL}${Label}${SELECT_WRAP_SYMBOL}`
    );
  });
}

export function getTypeaheadsForSearch(selectedObj) {
  return map(selectedObj, 'Typeahead');
}

function _getAutosuggestDetailsForAnalytics(analytics) {
  const wasShown = !isEmpty(analytics);
  const typedTermListed = every(analytics, (a) => a._typedTermListed);

  return `was-shown:${wasShown ? 'yes' : 'no'}|typed-term-listed:${typedTermListed ? 'yes' : 'no'}`;
}

export function getAnalyticsForSearch(selectedObj) {
  const analytics = map(selectedObj, 'analytics');
  const initSearchObj = {
    autoSuggestDetails: 'was-shown:no|typed-term-listed:no',
  };

  const combinedSearchObj = {
    ...reduce(analytics, (memo, obj) => mapValues(memo, (val, key) => (obj[key] ? `${val},${obj[key]}` : val))),
    autoSuggestDetails: _getAutosuggestDetailsForAnalytics(analytics),
  };

  return extend(initSearchObj, combinedSearchObj);
}
